<template>
  <div class="crm-export-loader">
    <div class="crm-label">
      <div class="linear-background">&nbsp;</div>
    </div>
    <div class="crm-list">
      <div class="crm-box linear-background"></div>
      <div class="crm-box linear-background"></div>
      <div class="crm-box linear-background"></div>
      <div class="crm-box linear-background"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CRM-Export-Loader',
  props: [],
  data: function() {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.crm-export-loader {
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  align-items: flex-start;
  .crm-label {
    margin-bottom: 10px;
    .linear-background {
      min-width: 120px;
      height: 15px;
      border-radius: 4px;
    }
  }
  .crm-list {
    display: flex;
    .crm-box {
      height: fit-content;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: space-evenly;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
}
</style>
